import React from "react";

export const HeartIcon = (props) => (
  <span className="heart" role="img" aria-label="heart-icon">
    {props.symbol}
  </span>
);
